export default __webpack_public_path__ + "static/media/640_portfolio04-fr-web.d28084d4.png";